import type { CurveTokens } from '../types';

export const curves: CurveTokens = {
  curveAccelerateMax: 'cubic-bezier(1,0,1,1)',
  curveAccelerateMid: 'cubic-bezier(0.7,0,1,0.5)',
  curveAccelerateMin: 'cubic-bezier(0.8,0,1,1)',
  curveDecelerateMax: 'cubic-bezier(0,0,0,1)',
  curveDecelerateMid: 'cubic-bezier(0.1,0.9,0.2,1)',
  curveDecelerateMin: 'cubic-bezier(0.33,0,0.1,1)',
  curveEasyEaseMax: 'cubic-bezier(0.8,0,0.1,1)',
  curveEasyEase: 'cubic-bezier(0.33,0,0.67,1)',
  curveLinear: 'cubic-bezier(0,0,1,1)',
};
